import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MODULES } from 'src/app/global-modules';
import { DirectivesModule } from '../directives/directives.module';
import { MessageInfoOverlayComponent } from './message-info-overlay/message-info-overlay.component';


@NgModule({
  declarations: [
    MessageInfoOverlayComponent
  ],
  imports: [
    CommonModule,
    ...MODULES,
    DirectivesModule
  ],
  exports: [
    MessageInfoOverlayComponent
  ]
})
export class SharedComponentsModule { }
